import emailConfirmationCheckboxTemplate from './bb_email_confirmation_checkbox.html';
import './bb_email_confirmation_checkbox.scss';

class EmailConfirmationCheckboxCtrl {

    constructor($translate, EmailConfirmationOptions, EmailConfirmationService) {
        this.$translate = $translate;
        this.EmailConfirmationOptions = EmailConfirmationOptions;
        this.EmailConfirmationService = EmailConfirmationService;
    }

    /**
     * @ngDoc method
     * @description Use configuration option as default
     */
    $onInit() {
        this.EmailConfirmationService.setEmailConfirmationFlag(this.EmailConfirmationOptions.isEmailConfirmationFlagChecked);
        this.emailConfirmation = this.EmailConfirmationService.isEmailConfirmationChecked();

        this.email = this.email || this.$translate.instant('ADMIN_BOOKING.CALENDAR.MOVE_BOOKING_CHECKBOX_DEFAULT_RECIPIENT');
    }

    /**
     * @ngDoc method
     * @description Changes state of confirmation after checkbox is clicked.
     */
    click() {
        this.EmailConfirmationService.swapEmailConfirmationFlag();
    }

}

const emailConfirmationCheckboxComponent = {
    bindings: {
        action: '@', 
        email: '@'
    },
    templateUrl: emailConfirmationCheckboxTemplate.id,
    controller: EmailConfirmationCheckboxCtrl
};

/**
 * @ngdoc component
 * @name BBAdminBooking.bbEmailConfirmationCheckbox
 *
 * @description
 * Simple checkbox element that allows to set mail confirmation flag on booking related actions (move, edit etc).
 *
 * @param {string} action Action which is being made (editing, moving, creating etc.).
 * @param {string} email Email address to be rendered near a checkbox.
 */
angular
    .module('BBPublicBooking')
    .component('bbEmailConfirmationCheckbox', emailConfirmationCheckboxComponent);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/email-confirmation-checkbox/bb_email_confirmation_checkbox.component.js